import firebase, { database } from "../firebase";
import * as actionTypes from "../actionTypes";
import * as constants from "../Constatnts";
import axios from "axios";




export function saveProductTag(key, productTag) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      let response;

      if (key && String(key).trim() !== "") {
        // UPDATE
        response = await axios.put(
          constants.API_URL + "/catalog/productGroup/" + key,
          productTag,
          config
        );
      } else {
        // CREATE
        response = await axios.post(
          constants.API_URL + "/catalog/productGroup",
          productTag,
          config
        );
      }

      if (
        response.data.code === "0"
      ) {
        if(key){
          return key
        }
        else{
          return response.data.data.key;
        }
      } else {
        var message =
          response &&
          response.data &&
          response.data.hasOwnProperty("message")
            ? response.data.message
            : "Failed to save product tag";

        throw new Error(message);
      }

    } catch (error) {
      console.error("Error saving product tag:", error);
      throw error;
    }
  };
}

// export function saveProductTag(key, tag) {
//   return (dispatch, getState) => {
//     if (key !== "") {
//       tag.Action = constants.AUDIT_TRAIL_EDIT;
//       return database
//         .collection("ProductTags")
//         .doc(key)
//         .update({
//           ...tag,
//         })
//         .then(() => {
//           return key;
//         })
//         .catch(function(error) {
//           console.error("Error updating Product Tags: ", error);
//         });
//     } else if (key == "") {
//       tag.Action = constants.AUDIT_TRAIL_NEW;
//       return database
//         .collection("ProductTags")
//         .add({
//           ...tag,
//         })
//         .then(function(docRef) {
//           return docRef.id;
//         })
//         .catch(function(error) {
//           console.error("Error adding Product Tags: ", error);
//         });
//     }
//   };
// }

export function getProductTags(registrationID) {
  return async (dispatch, getState) => {

    const token = getState().user.uat;

    const response = await axios.get(
      constants.API_URL + "/catalog/productGroup",
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    let productTags = [];

    if (
      response &&
      response.data &&
      Object.prototype.hasOwnProperty.call(response.data, "ProductGroups")
    ) {
      productTags = response.data.ProductGroups;

      dispatch({
        type: actionTypes.PRODUCT_TAGS_GET,
        productTags,
      });
    }

    // ✅ always return productTags
    return { productTags };
  };
}


export function deleteProductTag(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.delete(
        `${constants.API_URL}/catalog/productGroup/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // API-level error handling
      if (response.data.code !== "0") {
        throw new Error(response.data.message || "Delete failed");
      }

      return response.data;

    } catch (error) {
      console.error("Error deleting product group:", error);
      throw error;
    }
  };
}
// export function deleteProductTag(key) {
//   return async (dispatch, getState) => {
//     try {
//       const token = getState().user.uat;

//       const response = await axios.delete(
//         `${constants.API_URL}/catalog/productGroup/${key}`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       return response.data;
//     } catch (error) {
//       console.error("Error deleting product group:", error);
//       throw error;
//     }
//   };
// }
